import React from 'react';
import { useToast } from '../contexts/ToastContext';
import './Toast.css';

export const ToastDisplay = () => {
  const { toast, hideToast } = useToast();

  if (!toast) return null;

  return (
    <div className="toast-wrapper">
      <div className="toast toast-warn">
        <div className="toast-message">
          {toast.message}
        </div>
        <button className="toast-close" onClick={hideToast}>✕</button>
      </div>
    </div>
  );
};

// Default export used by components expecting a local toast UI
export default function Toast({ message, type = 'warn', onClose }) {
  const variantClass = type === 'error' ? 'toast-error' : type === 'success' ? 'toast-success' : 'toast-warn';
  return (
    <div className="toast-wrapper">
      <div className={`toast ${variantClass}`}>
        <div className="toast-message">{message}</div>
        <button className="toast-close" onClick={onClose || (() => {})}>✕</button>
      </div>
    </div>
  );
}
